var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextAlignRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 718.8 737.3",
    style: {
      enableBackground: "new 0 0 718.8 737.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M718.8,737.3v-109H202.1v109H718.8 M718.8,318.4V209.5H202.1v108.9H718.8 M718.8,527.8V418.9H0v108.9H718.8  M718.8,109V0H0v109H718.8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextAlignRightIcon);
export default __webpack_public_path__ + "static/media/text_align_right_icon.d3b79988.svg";
export { ForwardRef as ReactComponent };